angular.module('homebot.services', [])

  .factory('NotificationService', ['API_VARS', '$http', '$q', '$cookies', '$location', 'UtilService', 'HelperService', 'ApiHelperService', 'APP_CONFIG', function(API_VARS, $http, $q, $cookies, $location, utils, helpers, apiHelpers, APP_CONFIG){
    var client = window.stream.connect(APP_CONFIG.GETSTREAM_API_KEY, null, APP_CONFIG.GETSTREAM_API_APP);

    var services = {
      getNotifications: function(user, homeId){
        let userHomeTokens = _.where(user.notification_tokens, { 'home_ref': homeId });

        if (userHomeTokens.length > 0) {
          var userFeed = client.feed('user_home', `${user.id}_${homeId}`, userHomeTokens[0].token_value);

          return userFeed.get({ limit: 5 })
            .then((body) => { return body.results; })
            .catch((error) => { return console.log(error)} );
        } else {
          return $q.resolve([]);
        }
      },

      markNotificationsAsSeen: function(user, homeId){
        var userHomeTokens = _.where(user.notification_tokens, { 'home_ref': homeId });

        if (userHomeTokens.length > 0) {
          var userFeed = client.feed('user_home', `${user.id}_${homeId}`, userHomeTokens[0].token_value);

          return userFeed.get({ limit: 5, mark_seen: true })
                  .then((body) => { return true; })
                  .catch((error) => { return console.log(error)} );
        } else {
          return $q.resolve([]);
        }
      }
    }

    return services;
  }])

  .factory('DataService', ['API_VARS', '$http', '$q', '$cookies', '$location', 'UtilService', 'HelperService', 'ApiHelperService', function(API_VARS, $http, $q, $cookies, $location, utils, helpers, apiHelpers){

    var services = {
      getHome: function(args, homeId){
        var args = args || {};
        args.app = API_VARS.app;

        return $http.get(API_VARS.path+'/homes/'+homeId+'/detailed/', {params: args})
                  .then(apiHelpers.handleResponse)
                  .catch(apiHelpers.handleErrorButNoModify);
      },

      getHomeEmail: function (args, homeId) {
        var args = args || {}
        args.app = API_VARS.app

        return $http.post(API_VARS.path+'/homes/'+homeId+'/requestEmail', args)
                .then(apiHelpers.handleResponse)
                .catch(apiHelpers.handleError)
      },

      trackHome: function(args){
        args.app = API_VARS.app;

        return $http.post(API_VARS.path+'/homeActivities/track/', args)
                  .then(apiHelpers.handleResponse)
                  .catch(apiHelpers.handleError);
      },

      saveHome: function(args, homeId, isStatement){
        var args = args || {};

        if(isStatement){
          args.originalLoanAmount = 0;
        }else{
          args = _.merge(args, {
            statement: {
              payment: {
                interest: 0,
                principal: 0
              }
            }
          });
        }

        return $http.put(API_VARS.path+'/homes/'+homeId, args)
                  .then(apiHelpers.handleResponse)
                  .catch(apiHelpers.handleError);
      },

      saveAnswer: function(question, answer, homeId){
        var args = {
          question: question,
          answer: answer
        };

        return $http.post(API_VARS.path + '/homes/' + homeId + '/addAnswer', args)
          .then(apiHelpers.handleResponse)
          .catch(apiHelpers.handleError)
      },

      saveCMARequest: function(homeId, cmaBuyersAgentPreferred){
        var args = {data: {hasRequestedCMA: new Date()}};

        // TODO: this will be combined into one api call at some point
        return $http.post(API_VARS.path+'/homes/'+homeId+'/updateHome', args)
          .then(function(){
            if(typeof cmaBuyersAgentPreferred === 'undefined') return;
            return services.saveAnswer('cmaBuyersAgentPreferred', cmaBuyersAgentPreferred, homeId);
          });
      },

      addLoan: function(args, homeId){
        return $http.post(API_VARS.path+'/homes/'+homeId+'/createLoan', {data: args})
                  .then(apiHelpers.handleResponse)
                  .catch(apiHelpers.handleError);
      },

      saveLoan: function(loanProperties, loanId){
        return $http.put(API_VARS.path+'/homeLoans/'+loanId+'/editLoan', {data: loanProperties})
                  .then(apiHelpers.handleResponse)
                  .catch(apiHelpers.handleError);
      },

      confirmLoan: function(loan, loanId){
        var loanProperties = {
          rate: loan.rate,
          termYears: loan.termYears
        };

        return services.saveLoan(loanProperties, loanId);
      },

      deleteLoan: function(loanId){
        return $http.delete(API_VARS.path+'/homes/'+homeId+'/rloans/'+loanId)
                  .then(apiHelpers.handleResponse)
                  .catch(apiHelpers.handleError);
      },

      updateRealEstateAgent: function(id){
        return $http.get(API_VARS.path+'/realEstateAgents/'+id+'/updateData')
                  .then(apiHelpers.handleResponse)
                  .catch(apiHelpers.handleError);
      },

      emailSubscribe: {
        subscribe: function(userId){
          return $http.post(API_VARS.path+'/users/'+userId+'/emailDigests/subscribe')
                  .then(apiHelpers.handleResponse)
                  .catch(apiHelpers.handleError);
        },

        unsubscribe: function(userId){
          return $http.post(API_VARS.path+'/users/'+userId+'/emailDigests/unsubscribe')
                  .then(apiHelpers.handleResponse)
                  .catch(apiHelpers.handleError);
        }
      },

      avmHistory: function(homeId){
        return $http.get(API_VARS.path+'/homes/'+homeId+'/avmHistory/')
                  .then(apiHelpers.handleResponse)
                  .catch(apiHelpers.handleError);
      },

      addInvite: function(args){
        return $http.post(API_VARS.path+'/invites/referral/new', args)
                  .then(apiHelpers.handleResponse)
                  .catch(apiHelpers.handleError);
      },

      sendMessage: function(homeId, userId, agentId, message, topic){
        let args = { userId, agentId, message, topic };

        return $http.post(API_VARS.path + '/homes/' + homeId +'/messageAgent/', args)
                  .then(apiHelpers.handleResponse)
                  .catch(apiHelpers.handleError);
      },

      sendSponsorMessage: function(homeId, args){

        return $http.post(API_VARS.path + '/homes/' + homeId +'/messageSponsor/', args)
                  .then(apiHelpers.handleResponse)
                  .catch(apiHelpers.handleError);
      },

      getRentalPotential: function(homeId, args){
        return $http.get(`${API_VARS.path}/homes/${homeId}/rentalPotential/`, {params: args})
          .then(apiHelpers.handleResponse)
          .catch(apiHelpers.handleError);
      }

    };

    return services;
  }])

  .factory('AccessService', ['API_VARS', '$http', '$cookies', '$location', 'ApiHelperService', 'SessionService', function(API_VARS, $http, $cookies, $location, apiHelpers, SessionService){

    var service = {
      checkAndSetLocalToken: function(){
        if(SessionService.isAgent())
          return;

        var token = service.getUrlToken();

        if(!token) return;

        service.unsetUrlToken();

        service.setLocalToken(token);
      },

      getUrlToken: function(){
        var token = $location.search().tkn || null;
        return token;
      },

      setLocalToken: function(token){
        $cookies.put('accessToken',token, {path:'/', expires: moment().add(28, 'day').format()});
      },

      unsetLocalToken: function(){
        $cookies.put('accessToken', null, {path:'/'});
        $cookies.remove('accessToken');
      },

      unsetUrlToken: function(){
        $location.search('tkn', null).replace(); // replace ensures no back button
      },
    };

    return service;
  }])

  .factory('ChartService', ['HelperService', function(HelperService){
    return {
      marketRate: function(history){
        return history[0].USINTERESTRATE;
      },

      chartistRates: function(history, userInterestRate){
        var history = history.slice(0).reverse(); // clone array so it doesn't reverse original

        return {
          labels: _.map(history, 'WEEK'),
          series: [
            _.map(history, 'USINTERESTRATE'),
            HelperService.repeatArray(userInterestRate, history.length) // adds straight line of their rate
          ]
        }
      },

      chartistPaidSoFar: function(series){
        return {
          series: series.slice(0).reverse(),
          options: {
            showLabel: false,
          }
        }
      },

      chartistPaidSoFarBar: function(series){
        return {
          labels: ['Principal', 'Interest'],
          series: series
        }
      },

      chartistBarOptions: function(series){
        return {
          seriesBarDistance: 40,
          axisX:{
            showGrid: false,
            showLabel: false,
          },
          axisY:{
            position: 'end',
            showGrid: false,
            showLabel: false,
          },
          chartPadding: {
            bottom: 0,
            right: 0,
            left: 0
          },
          distributeSeries: true
        }
      }
    };

  }])

  .factory('UtilService', ['API_VARS', function(API_VARS){
    return {

      isValidResponse: function(response){
        if(response && response.error)
          return false;
        else if(response && response.status && (response.status >= 200 && response.status < 300))
          return true;
        else
          return false;
      },

      track: function(eventName, label){
        function getCategory(eventName){
          // if events are changed on the spreadsheet,
          // they should be copy pasted directly here
          // hence the weird colons and commas on spreadsheet
          var events = {
            CallRealEstateAgent: 1,
            EmailRealEstateAgent: 1,
            EquityLearnMore: 3,
            ChangeTheseValues: 3,
            RefiLearnMore: 2,
            RefiLetsDoIt: 1,
            RefiDoYouHaveBroker: 1,
            RefiCallMortgageBroker: 1,
            ReverseMortgageCallLender: 1,
            ReverseMortgageLearnMore: 2,
            RefiEmailMortgageBroker: 1,
            PayMonthlyLearnMore: 2,
            PayMonthlyLetsDoIt: 1,
            PayMonthlyDoYouHaveBroker: 1,
            PayMonthlyCallMortgageBroker: 1,
            PayMonthlyEmailMortgageBroker: 1,
            SaveNumbers: 2,
            CashoutLearnMore: 2,
            CashoutLetsDoIt: 1,
            CashoutDoYouHaveBroker: 1,
            CashoutCallMortgageBroker: 1,
            CashoutEmailMortgageBroker: 1,
            EstimateLearnMore: 2,
            CMARequest: 1,
            CMARequestSkipped: 1,
            CMARequestFinished: 1,
            CMAQuestionAnswered: 2,
            NumbersLookRight: 3,
            NightlyCallAgent: 1,
            NightlyEmailAgent: 1,
            NightlyAirbnbClick: 1,
            NightlyVRBOClick: 1,
            NightlyAirbnbNearbyClick: 1,
            DIYUpdatePayments: 3,
            NightlyUpdatePrice: 3,
            NightlyUpdateNights: 3,
            SaveMortgage: 2,
            AddMortgage: 2,
            DeleteMortgage: 2,
            ContactSupport: "Admin3",
            PmiKnownLoaded: 1,
            PmiEstimateLoaded: 1,
            PmiLearnMore: 2,
            PmiCallMortgageBroker: 1,
            PmiEmailMortgageBroker: 1,
            BillingAddCreditCard: "Admin2",
            BillingCreditCardSubmit: "Admin1",
            BillingCreditCardCancel: "Admin3",
            BuyingPowerCallMortgageBroker: 1,
            BuyingPowerEmailMortgageBroker: 1,
            InviteAnotherHomeowner: 1,
            ContestValue: 2,
            AirDNARequest: 3,
            AirDNALoaded: 3
          }

          if(events[eventName])
            return 'Category' + events[eventName];
          else
            return 'Uncategorized';
        }

        if(!eventName){
          ga('send', 'exception', {'exDescription': 'Tracking Error - Undefined Event'});
          return false;
        }

        var cat = getCategory(eventName);
        var label = label || null;

        ga('send', 'event', cat, eventName, label);
      },

      trackException: function(errorName, description){
        errorName = errorName || 'Uncategorized Error';
        description = description ? ' - ' + description : '';
        ga('send', 'exception', {'exDescription': errorName + description});
      }

    };
  }])

  .factory('ApiHelperService', ['$q', '$cookies', 'UtilService', 'HelperService', function($q, $cookies, utils, helpers){
    return {
      handleResponse: function(response){
        if(utils.isValidResponse(response))
          return $q.resolve(response.data);
        else
          return $q.reject(helpers.parseAPIError(response));
      },

      handleError: function(response){
        if(response && response.status === 401)
          $cookies.remove('accessToken');

        return $q.reject(helpers.parseAPIError(response));
      },

      handleErrorButNoModify: function (response) {
        if(response && response.status === 401)
          $cookies.remove('accessToken');

        return $q.reject(response);
      }
    }
  }])

  .factory('PageNotificationService', ['$timeout', '$rootScope', function($timeout, $rootScope){
    var autoCloseTimeout;

    var service = {
      success: function(message){
        service.notify(message, 'success', true);
      },

      info: function(message){
        service.notify(message, 'info', true);
      },

      error: function(message){
        service.notify(message, 'error', false);
      },

      close: function(){
        service.notify(null);
        service.closeListener(); // removes stateChange listener
      },

      notify: function(message, type, autoClose){
        if(autoCloseTimeout)
          $timeout.cancel(autoCloseTimeout);

        $rootScope.$broadcast('PageNotification', {
          message: message,
          type: type
        });

        if(autoClose)
          autoCloseTimeout = $timeout(service.close, 5000);

        service.closeOnStateChange();
      },

      closeOnStateChange: function(){
        service.closeListener = $rootScope.$on('$stateChangeStart', service.close);
      }
    };

    return service;
  }]);
